import { get, post, put } from '../../../utils/http';
import checkStatus from '../../../utils/checkStatus';
import * as constants from './messaging-constants';
import R from 'ramda';
import querystring from 'query-string';

export const updateProps = (type, payload) => ({
  type: constants.updateProps(type),
  payload,
});
export const downloadFromUrl = path => (dispatch, getState) => {
  const apiUrl = getState().config.get('apiUrl');
  return window.open(`${apiUrl}/s3/file?key=${encodeURIComponent(path)}`);
};

export const getPartners = payload => (dispatch) => {
  dispatch({ type: `${constants.GET_PARTNERS}_START` });
  return post(`/proxy/partner-management/partners`, payload)
    .then(checkStatus)
    .then(res => res.json())
    .then(res => {
      dispatch({ type: `${constants.GET_PARTNERS}_SUCCESS`, payload: res });
    });
};

export const createContractWithFiles = payload => (dispatch, getState) => {
  dispatch({ type: constants.CREATING_CONTRACT });
  const messageId = getState().messaging.actionDialog.getIn(['msg', 'messageId']);
  return post(`/proxy/contracting/contractWithFiles`, R.merge(payload, { messageId }))
    .then(checkStatus)
    .then(res => res.json())
    .then(res => {
      dispatch({ type: constants.CONTRACT_CREATED, payload: R.merge({ messageId }, res) });
      dispatch(initialLoadAMsg(messageId));
    })
    .catch(err => {
      console.log(err);
      dispatch({ type: constants.CREATE_CONTRACT_FAILED });
    });
};

export const addFilesToRequestsInDialog = (request, files) => (dispatch, getState) => {
  const { messageId } = getState().messaging.actionDialog.toJS().msg;
  return post('/proxy/contracting/contract/files', {
    contractId: request._id,
    files,
    messageId,
  })
    .then(checkStatus)
    .then(res => res.json())
    .then(() => {
      dispatch({
        type: constants.CONTRACT_CREATED,
        payload: R.merge(request, { messageId, files }),
      });
      dispatch(initialLoadAMsg(messageId));
    });
};

export const searchContractRequest = payload => (dispatch, getState) => {
  dispatch(updateProps('ACTION_DIALOG', { searchingRequests: true }));
  return get(
    `/proxy/contracting/requests?${querystring.stringify(
      R.merge(payload, {
        emails: JSON.stringify(payload.emails),
      }),
    )}`,
  )
    .then(checkStatus)
    .then(res => res.json())
    .then(res =>
      dispatch({
        type: 'GOT_MATCHED_REQUESTS_FOR_ADD_FILE_TO_CONTRACT',
        payload: { requests: res, searchByInput: payload.searchInput },
      }),
    )
    .catch(err => {
      console.log(err);
      dispatch(updateProps('ACTION_DIALOG', { searchingRequests: false }));
    });
};

export const initialLoadAMsg = messageId => dispatch => {
  dispatch({ type: constants.LOADING_MSGS, payload: true });
  return get(`/proxy/asset-activity/${messageId}`)
    .then(checkStatus)
    .then(res => res.json())
    .then(res => {
      dispatch({
        type: constants.MSGS_LOADED_INITIALLY,
        payload: {
          conv: res,
          messages: [res],
          messagesLoaded: true,
          loadingMessages: false,
        },
      });
      // mark read
      dispatch({
        type: '[workspace] CONVERSATIONS_READ_WITH_PARAMS',
        payload: {
          assetId: 'inbox',
          assetType: 'unassigned',
          messageId: res.messageId,
        },
      });
    })
    .catch(err => {
      console.log('loadConvList', err);
      dispatch({ type: constants.LOADING_MSGS, payload: false });
    });
};

export const loadConvList = (filter, loadFirstConv) => dispatch => {
  dispatch({ type: constants.LOADING_LIST });
  dispatch(updateProps('CONVS', { selectedConv: {} }));
  return get(`/proxy/asset-activities/inbox?assetType=unassigned`)
    .then(checkStatus)
    .then(res => res.json())
    .then(res => {
      dispatch({ type: constants.LIST_LOADED, payload: res });
      if (res && res[0] && loadFirstConv) {
        // since now this area is only for self forwarding
        // one conv is one message from workspacemessages
        dispatch({
          type: constants.MSGS_LOADED_INITIALLY,
          payload: {
            conv: res[0],
            messages: [res[0]],
            messagesLoaded: true,
            loadingMessages: false,
          },
        });
        dispatch({
          type: '[workspace] CONVERSATIONS_READ_WITH_PARAMS',
          payload: {
            assetId: 'inbox',
            assetType: 'unassigned',
            messageId: res[0].messageId,
          },
        });
      }
    })
    .catch(err => {
      console.log('loadConvList', err);
      dispatch({ type: constants.LOADING_LIST });
    });
};

export const toggleConvDone = (messageId, done) => (dispatch, getState) => {
  dispatch({ type: constants.TOGGLE_CONV_DONESS, payload: { messageId, done } });
  return put(`/proxy/asset-activity/${messageId}`, { assetId: 'inbox' })
    .then(checkStatus)
    .then(res => res.json())
    .then(res => {
      dispatch({
        type: constants.TOGGLE_CONV_DONESS_SUCCESS,
        payload: Object.assign({}, res, { messageId }),
      });
    })
    .catch(err => {
      dispatch({ type: constants.TOGGLE_CONV_DONESS, payload: { messageId, done: !done } });
    });
};



// WEBPACK FOOTER //
// ./src/app/components/messaging/messagingStore/messaging-actions.js